import auth from './auth'
import admin from './admin'
import dashboard from './dashboard'

export default [...admin, ...auth, ...dashboard]
